export { default as useToggleProductFavorite } from './useToggleProductFavorite';
